// LLM access gating (mirrors the backend account-tier gate).
//
// Token-spending endpoints (run start/advance, lecture explain/segment/understand,
// project run) reject users whose account tier is not LLM-enabled with a 403 whose
// detail is "llm_access_required". These helpers detect that case and produce the
// friendly blocked-state message shown across the generation surfaces.

import { ApiError } from "./client";

export const LLM_ACCESS_REQUIRED = "llm_access_required";

/** True when an error is the backend's "your account can't spend tokens" gate. */
export function isLlmAccessError(err: unknown): boolean {
  return (
    err instanceof ApiError &&
    err.status === 403 &&
    (err.code === LLM_ACCESS_REQUIRED || err.message === LLM_ACCESS_REQUIRED)
  );
}

/** The blocked-state message shown when a test-tier user attempts generation. */
export function llmBlockedMessage(t: (key: string) => string): string {
  return t(
    "Generation isn't enabled for your account yet — you're on the waitlist. You'll be able to create question sets once your access is approved.",
  );
}

/**
 * Map a generation error to a user-facing message: the blocked-state notice for
 * the LLM gate, otherwise the error's own message (or a fallback).
 */
export function generationErrorMessage(
  err: unknown,
  t: (key: string) => string,
  fallback?: string,
): string {
  if (isLlmAccessError(err)) return llmBlockedMessage(t);
  return err instanceof Error
    ? err.message
    : (fallback ?? t("Couldn't start generation."));
}
